import { AdminType, APIGet, APIPut, APIUrl } from "api/protocols";
import { CancelToken } from "axios";

interface IGetNewsLetterPosts {
  id?: number;
  facility_id: number;
  limit?: number;
  offset?: number;
}


export async function GetGuestNewsLetterPosts(params: IGetNewsLetterPosts, useGlobalLoader: boolean, cancelToken?: CancelToken) {
  return await APIGet(APIUrl(AdminType.Guest, "/facility/news-letter"), params, useGlobalLoader, cancelToken);
}

export async function PutGuestUnsubscribeNewsLetter(params: {unsubscribe_token: string}, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.Guest, "/facility/news-letter/subscriber/unsubscribe"), params, useGlobalLoader);
}
